<template>
  <editor-content :editor="editor"/>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Blockquote from '@tiptap/extension-blockquote'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Strike from '@tiptap/extension-strike'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'

export default {
  components: {
    EditorContent
  },
  props: {
    editorText: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      editor: new Editor({
        extensions: [
          StarterKit,  // Inclou funcionalitats bàsiques
          Blockquote,
          BulletList,
          ListItem,
          OrderedList,
          Bold,
          Italic,
          Strike,
          Underline,
          Link
        ],
        content: this.editorText,
        editable: false
      })
    }
  },
  beforeDestroy () {
    this.editor.destroy()
  }
}
</script>

<style scoped>
::v-deep .ProseMirror:focus {
  outline: none;
}
</style>
